import React__default from 'react';
import styled from 'styled-components';
import FuegokitLink from '../Link/Link.js';
import { get } from '../../constants.js';

/**
 * Navigation item for Global Header navigation
 */
const GlobalHeaderNavItem = ({
  href,
  label,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(StyledLink, {
    href: href
  }, label);
};
GlobalHeaderNavItem.displayName = "GlobalHeaderNavItem";
const StyledLink = styled(FuegokitLink).withConfig({
  displayName: "GlobalHeaderNavItem__StyledLink",
  componentId: "sc-7ps9wj-0"
})(["display:inline-block;color:inherit;margin-left:", ";font-weight:normal;font-size:", ";text-decoration:none;opacity:0.85;font-weight:", ";padding:10px 12px;border-radius:", ";&:hover,&:focus{opacity:1;text-decoration:none;color:", ";background-color:", ";}&:active{opacity:1;text-decoration:none;background-color:", ";}"], get('space.4'), get('fontSizes.2'), get('fontWeights.medium'), get('radii.1'), get('colors.link.default'), get('colors.background.neutral.subtle.hovered'), get('colors.background.selected.default.[default]'));
var GlobalHeaderNavItem$1 = GlobalHeaderNavItem;

export { GlobalHeaderNavItem$1 as default };
